import {AuthType} from './index'

export const convertVerifyModeToRequestParam = (
  verifyMode: VerifyMode,
): string => {
  switch (verifyMode) {
    case VerifyMode.Call:
      return 'call'
    case VerifyMode.SMS:
      return 'sms'
    case VerifyMode.Email:
      return 'email'
    default:
      throw new Error('Unsupported verify mode')
  }
}

export const convertIncomingToRequestParams = (
  incoming: Incoming,
): {email: string} | {num: string} =>
  incoming.type === AuthType.email
    ? {email: incoming.email}
    : {num: incoming.phone}

export type Incoming =
  | {type: AuthType.email; email: string}
  | {type: AuthType.phone; phone: string}

export type SocialIncoming =
  | {type: AuthType.facebook; token: string}
  | {type: AuthType.google; token: string}
  | {type: AuthType.apple; token: string}

export type Credentials =
  | {type: AuthType.email; email: string; password: string}
  | {type: AuthType.phone; phone: string}

export enum SupportProblemType {
  General = 0,
  Auth = 1,
}

export enum VerifyMode {
  Call,
  SMS,
  Email,
}

export interface AuthExistsResponse {
  readonly exists: boolean
  readonly verified: boolean
}

export interface AuthTokensResponse {
  readonly newAuth: {
    readonly hash: string
    readonly firstLogin: boolean
    readonly access: string
    readonly refresh: string
  }
  readonly oldAuth: {
    readonly hash: string
    readonly promo: string
  }
}

export interface ChangeContactResponseConflict {
  readonly key: string
  readonly description: string
  readonly select: string[]
}

export interface ChangeContactResponse {
  readonly conflicts?: ChangeContactResponseConflict[]
}

export interface ChangeContactRequestResolution {
  readonly key: string
  readonly value: string
}
